import ProductSolution from './ProductSolution'

export default ProductSolution
